import { gql } from "@apollo/client";

export const FETCH_CHATS = gql`
    query getChats($searchTerm: String, $visibility: String, $sortField: String, $sortOrder: String) {
        chats(searchTerm: $searchTerm, visibility: $visibility, sortField: $sortField, sortOrder: $sortOrder) {
            id
            createdAt
            updatedAt
            creatorId
            creatorName
            isPrivate
            isFavorite
            name
            generatedSummary
            sizeInTokens
            sizeInPages
            sizeInMessages
            totalTokensSpent
            totalPagesSpent
            settings
        }
    }
`;
